import { LanguageType } from '@/../../common/types/language';
import { isDev } from '@web/common/src/utils/util';
import dayjs from 'dayjs';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import bmCn from '../../locales/cn/BM/index.json';
import clcreditCn from '../../locales/cn/CL/credit.json';
import cmcCn from '../../locales/cn/CMC/index.json';
import commonCn from '../../locales/cn/common.json';
import billMgmtCn from '../../locales/cn/KKC/billMgmt.json';
import couponCn from '../../locales/cn/KKC/coupon.json';
import creditProcessCn from '../../locales/cn/KKC/creditprocess.json';
import eddaCn from '../../locales/cn/KKC/edda.json';
import mgmCn from '../../locales/cn/KKC/mgm.json';
import repaymentCn from '../../locales/cn/KKC/repayment.json';
import cn from '../../locales/cn/KKC/translation.json';
import withdrawalCn from '../../locales/cn/KKC/withdrawal.json';
import pubCn from '../../locales/cn/pub.json';
import vhkPubCn from '../../locales/cn/vhkPub.json';
import webPubCn from '../../locales/cn/webPub.json';
import bmEn from '../../locales/en/BM/index.json';
import clcreditEn from '../../locales/en/CL/credit.json';
import cmcEn from '../../locales/en/CMC/index.json';
import commonEn from '../../locales/en/common.json';
import billMgmtEn from '../../locales/en/KKC/billMgmt.json';
import couponEn from '../../locales/en/KKC/coupon.json';
import creditProcessEn from '../../locales/en/KKC/creditprocess.json';
import eddaEn from '../../locales/en/KKC/edda.json';
import mgmEn from '../../locales/en/KKC/mgm.json';
import repaymentEn from '../../locales/en/KKC/repayment.json';
import en from '../../locales/en/KKC/translation.json';
import withdrawalEn from '../../locales/en/KKC/withdrawal.json';
import pubEn from '../../locales/en/pub.json';
import vhkPubEn from '../../locales/en/vhkPub.json';
import webPubEn from '../../locales/en/webPub.json';
import bmZh from '../../locales/zh/BM/index.json';
import clcreditZh from '../../locales/zh/CL/credit.json';
import cmcZh from '../../locales/zh/CMC/index.json';
import commonZh from '../../locales/zh/common.json';
import billMgmtzh from '../../locales/zh/KKC/billMgmt.json';
import couponZh from '../../locales/zh/KKC/coupon.json';
import creditProcessZh from '../../locales/zh/KKC/creditprocess.json';
import eddazh from '../../locales/zh/KKC/edda.json';
import mgmZh from '../../locales/zh/KKC/mgm.json';
import repaymentzh from '../../locales/zh/KKC/repayment.json';
import zh from '../../locales/zh/KKC/translation.json';
import withdrawalzh from '../../locales/zh/KKC/withdrawal.json';
import pubZh from '../../locales/zh/pub.json';
import vhkPubZh from '../../locales/zh/vhkPub.json';
import webPubZh from '../../locales/zh/webPub.json';

export const initLanguage = (curLang: LanguageType) => {
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: curLang, // 默认语言
      fallbackLng: 'en', // 如果没有对应语言文件，则使用默认语言
      debug: isDev(), // 开启调试模式
      interpolation: {
        escapeValue: false, // 不需要 HTML 转义
      },
      resources: {
        en: {
          translation: {
            ...en,
            ...creditProcessEn,
            ...commonEn,
            ...pubEn,
            ...withdrawalEn,
            ...eddaEn,
            ...repaymentEn,
            ...billMgmtEn,
            ...mgmEn,
            ...vhkPubEn,
            ...clcreditEn,
            ...couponEn,
            ...cmcEn,
            ...webPubEn,
            ...bmEn,
          },
        },
        zh: {
          translation: {
            ...zh,
            ...creditProcessZh,
            ...commonZh,
            ...pubZh,
            ...withdrawalzh,
            ...eddazh,
            ...repaymentzh,
            ...billMgmtzh,
            ...mgmZh,
            ...vhkPubZh,
            ...clcreditZh,
            ...couponZh,
            ...cmcZh,
            ...webPubZh,
            ...bmZh,
          },
        },
        cn: {
          translation: {
            ...cn,
            ...creditProcessCn,
            ...commonCn,
            ...pubCn,
            ...withdrawalCn,
            ...eddaCn,
            ...repaymentCn,
            ...billMgmtCn,
            ...mgmCn,
            ...vhkPubCn,
            ...clcreditCn,
            ...couponCn,
            ...cmcCn,
            ...webPubCn,
            ...bmCn,
          },
        },
      },
    });

  dayjs.locale(curLang === 'en' ? 'en-us' : 'zh-hk');
};

export const changeLanguage = (curLang: LanguageType) => {
  i18n.changeLanguage(curLang);
  dayjs.locale(curLang === 'en' ? 'en-us' : 'zh-hk');
};
